import React from 'react';
import logo from '../../../assets/simple_logo.svg';
import '../../../css/Footer.css';

function Footer() {
    const navItems = [
        { id: '/privacy-policy', label: 'Privacy' },
        { id: '/terms-of-service', label: 'Terms' },
        { id: '/faq', label: 'FAQ' }
    ];

    return (
        <footer className={'footerContainer'}>
            <div className={'footerWrapper'}>
                <nav className={'footerContent'}>
                    <div className={'brandContainer'}>
                        <img
                            loading="lazy"
                            src={logo}
                            className={'brandLogo'}
                            alt="Mentium.pro logo"
                        />
                        <p className={'copyright'}>© 2025 Mentium.pro</p>
                    </div>
                    <div className={'footerNavLinks'} role="navigation">
                        {navItems.map((item, index) => (
                            <div className={'footerNavSet'} key={item.id}>
                                <div className={`footerNavDivider ${index === 0 ? 'first' : ''}`} />
                                <a
                                    key={item.id}
                                    href={`${item.id}`}
                                    className={'footerNavLink'}
                                    tabIndex="0"
                                >
                                    {item.label}
                                </a>
                            </div>
                        ))}
                    </div>
                </nav>
            </div>
        </footer>
    );
}

export default Footer;
